import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const OrderCancelledBadge = (props: BadgeProps): React.ReactElement => (
  <Badge
    {...props}
    icon={"CLOSE"}
    className={twMerge("bg-red-100 text-red-700", props.className)}
  >
    Order cancelled
  </Badge>
);
